import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/code_gzh.png'
import _imports_1 from '@/assets/code_xcx.png'


const _withScopeId = n => (_pushScopeId("data-v-0f46c661"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-0f46c661><div class=\"text\" data-v-0f46c661><div class=\"cont\" data-v-0f46c661><div class=\"iconfont icon-dianhua\" data-v-0f46c661>联系电话：0769-22883352</div><div class data-v-0f46c661><span class=\"textCenter f_12\" data-v-0f46c661>© Copyright 2025广东择才猫科技有限公司</span><a class=\"textCenter f_12 pointer textLink marginL10\" href=\"https://beian.miit.gov.cn/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-0f46c661>粤ICP备2021161038号</a></div></div><div class=\"cont\" data-v-0f46c661><div class=\"iconfont icon-didian\" data-v-0f46c661> 广东省东莞市南城街道<br data-v-0f46c661> 车站路16号南城碧桂园1号楼1810室 </div></div><div class=\"code_img textCenter\" data-v-0f46c661><img src=\"" + _imports_0 + "\" data-v-0f46c661><div class=\"f_12\" data-v-0f46c661>择才猫公众号</div></div><div class=\"code_img textCenter\" data-v-0f46c661><img src=\"" + _imports_1 + "\" data-v-0f46c661><div class=\"f_12\" data-v-0f46c661>择才猫小程序</div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "p_footer"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-0f46c661><div class=\"text\" data-v-0f46c661><div class=\"code\" data-v-0f46c661><div class=\"code_img textCenter\" data-v-0f46c661><img src=\"" + _imports_0 + "\" data-v-0f46c661><div class data-v-0f46c661>择才猫公众号</div></div><div class=\"code_img textCenter\" data-v-0f46c661><img src=\"" + _imports_1 + "\" data-v-0f46c661><div class data-v-0f46c661>择才猫小程序</div></div></div><div class=\"cont\" data-v-0f46c661><div class=\"iconfont icon-dianhua\" data-v-0f46c661><span class=\"c999\" data-v-0f46c661>联系电话：0769-22883352</span></div><div class=\"iconfont icon-didian\" data-v-0f46c661><span class=\"c999\" data-v-0f46c661>广东省东莞市南城街道车站路16号南城碧桂园1号楼1810室</span></div><div class=\"iconfont\" data-v-0f46c661><span class=\"c999\" data-v-0f46c661>© Copyright 2025广东择才猫科技有限公司</span><a class=\"pointer textLink marginL10\" href=\"https://beian.miit.gov.cn/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-0f46c661>粤ICP备2021161038号</a></div></div></div></div>", 1)
const _hoisted_6 = [
  _hoisted_5
]

import { getCurrentInstance, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'footer',
  emits: ["updateScroll"],
  setup(__props, { emit }: { emit: ({
  (e: "updateScroll", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const { $utils } = getCurrentInstance().appContext.config.globalProperties;

const route = useRoute();
const router = useRouter();
let list = [
  { title: "首页", type: 1, route: "home", path: "/home" },
  { title: "背调方案", type: 2, route: "scheme", path: "/scheme" },
  { title: "背调项目", type: 3, route: "surveyDetails", path: "/surveyDetails" },
  { title: "核心价值", type: 4, route: "apiServe", path: "/apiServe" },
  { title: "背调流程", type: 5, route: "flowPath", path: "/flowPath" },
  { title: "关于我们", type: 6, route: "aboutUs", path: "/aboutUs" },
  // { title: "首页", type: 1, route: "home", path: "/home" },
  // { title: "解决方案", type: 2, route: "scheme", path: "/scheme" },
  // { title: "背调流程", type: 3, route: "flowPath", path: "/flowPath" },
  // { title: "背调内容", type: 4, route: "surveyDetails", path: "/surveyDetails" },
  // { title: "API服务", type: 5, route: "apiServe", path: "/apiServe" },
  // { title: "关于我们", type: 7, route: "aboutUs", path: "/aboutUs" },
];
// 路由跳转
const toRoute = (key) => {
  for (const i in list) {
    let item = list[i];
    if (key == item.type) {
      router.push(item.path);
      if (item.route == route.name) {
        return;
      }
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref($utils).isMobile())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_unref($utils).isMobile())
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}
}

})